import { Injectable, Injector, ApplicationRef, ComponentFactoryResolver, EmbeddedViewRef } from '@angular/core';
import { TimePickerComponent } from './time-picker/time-picker.component';
import { TimePickerConfig, IDialogResult } from './definitions';

// We need to import like this, because of backward compatibility of angular
/* tslint:disable */

import { Subject } from 'rxjs';
/* tslint:enable */

import { Preference } from './preferences';
export class AmazingTimePickerService {
/**
 * @param {?} resolver
 * @param {?} appRef
 * @param {?} injector
 */
constructor (
private resolver: ComponentFactoryResolver,
private appRef: ApplicationRef,
private injector: Injector
  ) {}
/**
 * @param {?=} config
 * @return {?}
 */
open (config?: TimePickerConfig): IDialogResult {
    const /** @type {?} */ thems = ['light', 'dark', 'material-red', 'material-green', 'material-blue', 'material-purple', 'material-orange'];
    const /** @type {?} */ _self = this;
    config = config || {};
    config = /** @type {?} */(( {
      time: config.time || '00:00',
      theme: thems.indexOf(config.theme) > 0 ? config.theme : 'light' || config.theme || 'light',
      rangeTime: config.rangeTime || {start: '0:0', end: '24:0'},
      arrowStyle: config.arrowStyle || {},
      locale: config.locale || 'en',
      changeToMinutes: config.changeToMinutes,
      animation: (config.animation == null || config.animation === 'fade') ? 'fade' : (config.animation === 'rotate') ? 'rotate' : false,
      preference: config.preference || null,
      onlyHour: config.onlyHour,
      onlyMinute: config.onlyMinute,
      onlyAM: config.onlyAM,
      onlyPM: config.onlyPM,
    } as TimePickerConfig));
    config.rangeTime = {
      start: config.rangeTime.start || '0:0',
      end: config.rangeTime.end || '24:0',
    };
    config.arrowStyle = {
      background: (config.arrowStyle.background) ?
      config.arrowStyle.background : config.theme !== undefined ?
      config.theme === 'dark' ? 'rgb(128, 203, 196)' : '' : '',
      color: config.arrowStyle.color || ''
    };
    const /** @type {?} */ componentRef = this.resolver.resolveComponentFactory(TimePickerComponent);
    const /** @type {?} */ tsc = componentRef.create(this.injector);
    this.appRef.attachView(tsc.hostView);
    const /** @type {?} */ domElem = /** @type {?} */(( ( /** @type {?} */((tsc.hostView as EmbeddedViewRef<any>))).rootNodes[0] as HTMLElement));
    document.body.appendChild(domElem);
    tsc.instance.subject = new Subject<any>();
    tsc.instance._ref = tsc;
    tsc.instance.appRef = this.appRef;
    tsc.instance.timerElement = '';
    tsc.instance.config = config;
    if (config.preference) {
      tsc.instance.preference = config.preference;
    } else {
      tsc.instance.preference = Preference(config.locale);
    }
    tsc.instance.ParseStringToTime(config.time);
    return {
      afterClose: function () {
        return tsc.instance.subject.asObservable();
      }
    };
  }
static decorators: DecoratorInvocation[] = [
{ type: Injectable },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: ComponentFactoryResolver, },
{type: ApplicationRef, },
{type: Injector, },
];
}

function AmazingTimePickerService_tsickle_Closure_declarations() {
/** @type {?} */
AmazingTimePickerService.decorators;
/**
 * @nocollapse
 * @type {?}
 */
AmazingTimePickerService.ctorParameters;
/** @type {?} */
AmazingTimePickerService.prototype.resolver;
/** @type {?} */
AmazingTimePickerService.prototype.appRef;
/** @type {?} */
AmazingTimePickerService.prototype.injector;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
